<mat-card class="cardWithShadow overflow-hidden">
    <!-- ------------------------------------------------------ -->
    <!-- Toggle mobile -->
    <!-- ------------------------------------------------------ -->
    <mat-card-header class="bg-primary text-white p-10 d-block d-lg-none">
        <mat-card-title class="m-b-0">
            <div class="d-flex align-items-center">
                <button (click)="clinicalnav.toggle()" mat-icon-button>
                    <mat-icon>short_text</mat-icon>
                </button>
                <div class="mat-subheading-1 m-b-0 m-l-16">{{ selectedDate | date: "EEEE , MMMM dd, y" }}</div>
            </div>
        </mat-card-title>
    </mat-card-header>
    <!-- ------------------------------------------------------ -->
    <!-- Desktop App -->
    <!-- ------------------------------------------------------ -->
    <mat-sidenav-container class="email-box" [ngClass]="{
        'side-panel-opened': sidePanelOpened(),
        'side-panel-closed': !sidePanelOpened()
      }">

        <!-- ------------------------------------------------------ -->
        <!-- Sidebar Email -->
        <!-- ------------------------------------------------------ -->
        <mat-sidenav #clinicalnav [mode]="isOver() ? 'over' : 'side'" [opened]="!isOver()"
            (open)="sidePanelOpened.set(true)" (close)="sidePanelOpened.set(false)" class="mail-sidebar">
            <ng-scrollbar style="height: calc(100vh - 80px)" class="position-relative">

                <div class="rounded p-15 overflow-hidden">
                    <div class="left-section">
                        <!-- Details Layout -->
                        <mat-card class=" details-layout">
                            <mat-card-content class="p-0">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <span class="f-w-600 f-s-16">
                                            {{ selectedDate | date: "EEEE , MMMM dd, y" }}
                                        </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-8">
                                        <mat-form-field appearance="outline" class="hide-hint m-t-20 d-column">
                                            <mat-label>{{ 'LABEL.DOCTORS' | translate }}</mat-label>
                                            <mat-select required [(value)]="selectedDoctorId"
                                                (valueChange)="onChange($event)">
                                                <mat-option *ngFor="let doctor of doctorslist" [value]="doctor.id">
                                                    {{ doctor.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-sm-4 m-t-15 justify-content-start">
                                        <a mat-icon-button (click)="printAppointmentSchedule()">
                                            <i-tabler name="printer" class="text-primary icon-25 d-flex "></i-tabler>
                                        </a>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>

                        <!-- Calendar Section -->
                        <mat-card class="calendar-container cardWithShadow">
                            <mat-calendar [dateClass]="dateClass" #calendar [(selected)]="selectedDate"
                                (selectedChange)="onDateChange($event)" [dateFilter]="dateFilter"></mat-calendar>
                        </mat-card>
                    </div>
                </div>

            </ng-scrollbar>
        </mat-sidenav>
        <!-- ------------------------------------------------------ -->
        <!-- Email Listing and Details-->
        <!-- ------------------------------------------------------ -->
        <!-- <div class="main-content"> -->
        <mat-card class="table-container m-0">
            <mat-card-content class="p-0">
                <div class="table-wrapper table-responsive">
                    <ng-container *ngIf="dataSource.data.length > 0 && !noSlotsAvailable;">
                        <table mat-table [dataSource]="dataSource" class="appointment-table">
                            <!-- Slots -->
                            <ng-container matColumnDef="Slots">
                                <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
                                    {{ 'LABEL.SLOTS' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let element">{{ element.time }}</td>
                            </ng-container>

                            <!-- Name -->
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
                                    {{ 'LABEL.NAME' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let element; let i = index">
                                    <p class="f-w-600 mat-subtitle-1 f-s-16 m-0" *ngIf="showInputIndex !== i">
                                        {{ element.appointment?.patientName }}
                                    </p>
                                </td>
                            </ng-container>

                            <!-- OPD No -->
                            <ng-container matColumnDef="opdno">
                                <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
                                    {{ 'LABEL.OPD_NO' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.appointment?.opdNumber }}
                                </td>
                            </ng-container>

                            <!-- Appointment Type -->
                            <ng-container matColumnDef="appointmentType">
                                <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
                                    {{ 'ENTITY.APPOINTMENT_TYPE' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.appointment?.appointmentTypeName }}
                                </td>
                            </ng-container>

                            <!-- Status -->
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
                                    {{ 'LABEL.STATUS' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.appointment?.status }}
                                </td>
                            </ng-container>

                            <!-- Value -->
                            <ng-container matColumnDef="value">
                                <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
                                    {{ 'LABEL.VALUE' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.appointment?.charge }}
                                </td>
                            </ng-container>

                            <!-- Mobile -->
                            <ng-container matColumnDef="mobile">
                                <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
                                    {{ 'LABEL.MOBILE_LABEL' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{ element.appointment?.patientContact }}
                                </td>
                            </ng-container>

                            <!-- Action -->
                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600 sticky">
                                    {{ 'LABEL.ACTION_LABEL' | translate }}
                                </th>
                                <td mat-cell *matCellDef="let element; let i = index" class="action-link">
                                    <ng-container *ngIf="element.appointment?.patientId">
                                        <div class="d-flex align-items-center gap-10 action-row">
                                            <!-- Start Consultation -->
                                            <a matTooltip="Start Consultation"
                                                *ngIf="isTodayOrInThePast(element.appointment.appointDate) && !element.appointment.opdNumber"
                                                (click)="onStartConsultation(element.appointment, $event)">
                                                <i-tabler name="message" class="icon-20"></i-tabler>
                                            </a>

                                            <!-- Edit/View Consultation -->
                                            <a matTooltip="Edit/View Consultation" *ngIf="element.appointment.opdNumber"
                                                (click)="onStartConsultation(element.appointment, $event)">
                                                <i-tabler name="eye-edit" class="icon-20"></i-tabler>
                                            </a>

                                            <!-- Delete -->
                                            <a matTooltip="Delete" *ngIf="!element.appointment.opdNumber"
                                                (click)="onDeleteAppointment(element.appointment, $event)">
                                                <i-tabler name="trash" class="icon-20"></i-tabler>
                                            </a>

                                            <!-- Dropdown -->
                                            <a [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                                                <i-tabler name="dots-vertical" class="icon-20"></i-tabler>
                                            </a>

                                            <mat-menu #menu="matMenu">
                                                <a mat-menu-item
                                                    (click)="listOfPatientByAppointment(element.appointment)">
                                                    {{ 'ENTITY.PATIENT' | translate }} {{ 'ENTITY.APPOINTMENT' |
                                                    translate }} {{ 'LABEL.HISTORY' | translate }}
                                                </a>
                                                <a mat-menu-item *ngIf="element.appointment.opdNumber"
                                                    (click)="listOfPatientReport(element.appointment)">
                                                    {{ 'ENTITY.PATIENT' | translate }} {{ 'LABEL.REPORT' | translate }}
                                                </a>
                                                <a mat-menu-item *ngIf="element.appointment.opdNumber"
                                                    (click)="onBillChargeAdd(element)">
                                                    {{ 'ENTITY.BILL' | translate }} {{ 'LABEL.RECEIPT' | translate }}
                                                </a>
                                            </mat-menu>
                                        </div>
                                    </ng-container>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
                           <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{
      'booked-row': row.appointment && row.appointment.status !== 'Attended',
      'ipd-row': isIPD && row.appointment?.ipdId && row.appointment.ipdId !== 0
    }" (click)="onAddAppointmentPopup(row)"></tr>
                        </table>
                    </ng-container>
                </div>
            </mat-card-content>
        </mat-card>
        <!-- </div> -->
    </mat-sidenav-container>
</mat-card>